import type { Component } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import _ from 'lodash'
import type { CssFeature } from './cssFeature.types'

export const componentCssFactory = (cssFeatures: Array<CssFeature<any, any>>) =>
	createCompNode({
		getDependencies: (component: Component, refs: any) => {
			const seed: any = {
				breakpointsOrder: component.breakpointVariantsQuery
					? refs.breakpointVariantsQuery(component.breakpointVariantsQuery)
					: undefined,
				compSpecificData: {
					visibilityTransformations: refs.visibilityTransformations(component),
				},
			}

			if (component.patternsQuery) {
				seed.compSpecificData.patterns = {
					[component.id]: refs.repeaterPatterns(component),
				}
			}

			return cssFeatures.reduce((acc, feature) => {
				acc[feature.featureName] = _.mapValues(feature.renderableNodes, (__, compNodeName) =>
					refs[compNodeName](component)
				)
				return acc
			}, seed)
		},
		toViewItem: (__, deps) => deps,
	})
